import { ScaleManager } from "./Utils/ScaleManager";
import { Gameplay } from "./Gameplay/Gameplay";
import { AssetLoader } from "./Utils/AssetLoader";
import { SoundManager } from "./Utils/SoundManager";
import { eCapability as eGameeCapability } from "./Gamee/Gamee";
import * as Gamee from "./Gamee/GameeWrapper";
import { RND } from "./Utils/RND";


//export const FPS_METER = new FPSMeter(undefined, { graph: 1 });


export const enum eModelAsset {
    barrier = "barrier",
    bonus2x = "bns2x",
    bonusShield = "bnsShield",
    box = "box_0",
    bridge = "bridge",
    building_0 = "building_0",
    building_1 = "building_1",
    building_2 = "building_2",
    car_0 = "car_0",
    car_1 = "car_1",
    cone = "cone",
    parcelCollectionCarousel = "dispBelt",
    parcelCollection = "dispBuilding",
    flowerPot = "flowerPot",
    ground_0 = "groundBorder_0",
    ground_1 = "groundCentre_0",
    road = "groundRoad_0",
    safeArea_0 = "groundSafeArea_0",
    pallet = "pallet",
    parcel = "parcel",
    player = "player",
    post = "post",
    river = "river",
    tree = "tree",
    van = "van",
    wall = "wall",
}



export const enum eFontAsset {
    default = "fntDefault",
}



export const enum eTextureAsset {
    conveyorBelt = "conveyorBelt",
    shield = "shield",
    water = "water",
}



export const enum eAtlas_0 {
    NAME = "atlas_0",

    deliveryBnsBar = "deliveryBnsBar",
    deliveryBnsBarFill = "deliveryBnsBarFill",
    deliveryBnsIcon_0 = "deliveryBnsIcon_0",
    deliveryBnsIcon_1 = "deliveryBnsIcon_1",
    scoreMultiBar = "scoreMultiBar",
    scoreMultiBarFill = "scoreMultiBarFill",
    shieldBar = "shieldBar",
    shieldBarFill = "shieldBarFill",
    keepPlaying = "keepPlaying",
    btnWatchAd_0 = "btnWatchAd_0",
    btnWatchAd_1 = "btnWatchAd_1",
    btnNoThanks_0 = "btnNoThanks_0",
    btnNoThanks_1 = "btnNoThanks_1",
}



export const enum eAudioAsset {
    sfx = "sfx",
    music = "music"
}



export const enum eSfxSprite {
    barrierDown = "barrierDown",
    bonusPickup = "bonusPickup",
    carEngine = "carEngine",
    carHit = "carHit",
    conveyorBeltMove = "convBeltMove",
    pkgDelivery = "pkgDelivery",
    pkgPickup = "pkgPickup",
    plDeath = "plDeath",
    plChangeDir_0 = "plChangeDir_0",
    plChangeDir_1 = "plChangeDir_1",
    waterSplash = "waterSplash"
}



export const enum eAnimation {
    carDrive_0 = "carDrive_0",
    carDrive_1 = "carDrive_1"
}



export const SfxSprites = {
    "barrierDown": {
        "start": 0,
        "end": 0.8592063492063492,
        "loop": false
    },
    "bonusPickup": {
        "start": 2,
        "end": 2.5,
        "loop": false
    },
    "carEngine": {
        "start": 4,
        "end": 10,
        "loop": false
    },
    "carHit": {
        "start": 11,
        "end": 12.397256235827664,
        "loop": false
    },
    "convBeltMove": {
        "start": 14,
        "end": 18,
        "loop": false
    },
    "pkgDelivery": {
        "start": 19,
        "end": 19.530861678004534,
        "loop": false
    },
    "pkgPickup": {
        "start": 21,
        "end": 21.25,
        "loop": false
    },
    "plDeath": {
        "start": 23,
        "end": 23.437052154195012,
        "loop": false
    },
    "plChangeDir_0": {
        "start": 25,
        "end": 25.25,
        "loop": false
    },
    "plChangeDir_1": {
        "start": 27,
        "end": 27.388390022675736,
        "loop": false
    },
    "waterSplash": {
        "start": 29,
        "end": 32,
        "loop": false
    }
}



/**
 * Global random number generator
 */
export const rnd = new RND(Math.random() * 7548624);



export class Game {
    /**
     * Opacity pro falesny stin
     */
    static readonly FAKE_SHADOW_OPACITY = 0.35;

    static get APP(): pc.Application { return Game._APP; }
    private static _APP: pc.Application;

    static get SCALE(): ScaleManager { return this._SCALE; }
    private static _SCALE: ScaleManager

    /**
     * (RO) True, pokud je hra pozastavena
     */
    static get PAUSED(): boolean { return Game._PAUSED; }
    private static _PAUSED: boolean = false;

    private static _LOADER: AssetLoader;

    private _gameplay: Gameplay;

    private static readonly _FLAG_GAMEE_INITIALIZED = 0x0001;
    private static readonly _FLAG_ASSETS_LOADED = 0x0002;

    private _flags: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(canvasID: string) {
        this._flags = 0;

        // Gamee        
        Gamee.Wrapper.EVENTS.on(Gamee.eEvent.start, () => { Game._PAUSED = false; });
        Gamee.Wrapper.EVENTS.on(Gamee.eEvent.pause, () => { SoundManager.pause(); Game._PAUSED = true; });
        Gamee.Wrapper.EVENTS.on(Gamee.eEvent.resume, () => { SoundManager.resume(); Game._PAUSED = false; });
        Gamee.Wrapper.EVENTS.on(Gamee.eEvent.mute, () => { SoundManager.stop(); SoundManager.mute = true; });
        Gamee.Wrapper.EVENTS.on(Gamee.eEvent.unmute, () => { SoundManager.mute = false; });

        Gamee.Wrapper.gameInit([eGameeCapability.logEvents, eGameeCapability.rewardedAds], () => {
            // Povolit/zakazat zvuk
            if (Gamee.Wrapper.INIT_DATA)
                SoundManager.mute = !Gamee.Wrapper.INIT_DATA.sound;

            this.handleInitProgress(Game._FLAG_GAMEE_INITIALIZED);
        }, this);

        // Vytvorit pc.Application
        let canvas = document.getElementById(canvasID) as HTMLCanvasElement;

        Game._APP = new pc.Application(canvas, {
            keyboard: new pc.Keyboard(window),
            mouse: new pc.Mouse(canvas),
            touch: new pc.TouchDevice(canvas),
            elementInput: new pc.ElementInput(canvas)
        });
        Game._APP.setCanvasFillMode(pc.FILLMODE_NONE);
        Game._APP.addTweenManager();
        Game._APP.start();

        // Scaling
        Game._SCALE = new ScaleManager(Game._APP, new pc.Vec2(560, 800), new pc.Vec2(560, 1120));
        Game._SCALE.resize();

        Game._APP.scene.gammaCorrection = pc.GAMMA_SRGBFAST;

        // Loader
        Game._APP.assets.on(AssetLoader.EVENT_LOADED, this.handleLoaderComplete, this);

        Game._LOADER = new AssetLoader(Game._APP.assets, "assets/");

        Game._LOADER.addAsset(eModelAsset.barrier, pc.eAssetType.model, "barrier.json");
        Game._LOADER.addAsset(eModelAsset.bonus2x, pc.eAssetType.model, "bonus_2x.json");
        Game._LOADER.addAsset(eModelAsset.bonusShield, pc.eAssetType.model, "bonus_shield.json");
        Game._LOADER.addAsset(eModelAsset.box, pc.eAssetType.model, "box.json");
        Game._LOADER.addAsset(eModelAsset.bridge, pc.eAssetType.model, "bridge.json");
        Game._LOADER.addAsset(eModelAsset.building_0, pc.eAssetType.model, "building_1.json");
        Game._LOADER.addAsset(eModelAsset.building_1, pc.eAssetType.model, "building_2.json");
        Game._LOADER.addAsset(eModelAsset.building_2, pc.eAssetType.model, "building_3.json");
        Game._LOADER.addAsset(eModelAsset.car_0, pc.eAssetType.model, "car_1.json");
        Game._LOADER.addAsset(eModelAsset.car_1, pc.eAssetType.model, "car_2.json");
        Game._LOADER.addAsset(eModelAsset.cone, pc.eAssetType.model, "cone.json");
        Game._LOADER.addAsset(eModelAsset.player, pc.eAssetType.model, "deliveryGuy.json");
        Game._LOADER.addAsset(eModelAsset.flowerPot, pc.eAssetType.model, "flowerPot.json");
        Game._LOADER.addAsset(eModelAsset.ground_0, pc.eAssetType.model, "ground_1.json");
        Game._LOADER.addAsset(eModelAsset.ground_1, pc.eAssetType.model, "ground_2.json");
        Game._LOADER.addAsset(eModelAsset.safeArea_0, pc.eAssetType.model, "ground_safeArea.json");
        Game._LOADER.addAsset(eModelAsset.pallet, pc.eAssetType.model, "pallet.json");
        Game._LOADER.addAsset(eModelAsset.parcel, pc.eAssetType.model, "parcel.json");
        Game._LOADER.addAsset(eModelAsset.parcelCollection, pc.eAssetType.model, "parcelCollection.json");
        Game._LOADER.addAsset(eModelAsset.parcelCollectionCarousel, pc.eAssetType.model, "parcelCollectionCarousel.json");
        Game._LOADER.addAsset(eModelAsset.post, pc.eAssetType.model, "post.json");
        Game._LOADER.addAsset(eModelAsset.river, pc.eAssetType.model, "river.json");
        Game._LOADER.addAsset(eModelAsset.road, pc.eAssetType.model, "road.json");
        Game._LOADER.addAsset(eModelAsset.tree, pc.eAssetType.model, "tree.json");
        Game._LOADER.addAsset(eModelAsset.van, pc.eAssetType.model, "van.json");
        Game._LOADER.addAsset(eModelAsset.wall, pc.eAssetType.model, "wall.json");

        Game._LOADER.addAsset(eAnimation.carDrive_0, pc.eAssetType.animation, "animCar_0.json");
        Game._LOADER.addAsset(eAnimation.carDrive_1, pc.eAssetType.animation, "animCar_1.json");

        Game._LOADER.addAsset(eFontAsset.default, pc.eAssetType.font, "fonts/Minercraftory.json");

        Game._LOADER.addAsset(eTextureAsset.conveyorBelt, pc.eAssetType.texture, "texConveyor.png");
        Game._LOADER.addAsset(eTextureAsset.shield, pc.eAssetType.texture, "texShield.png");
        Game._LOADER.addAsset(eTextureAsset.water, pc.eAssetType.texture, "texWater.png");

        Game._LOADER.addAsset(eAtlas_0.NAME, pc.eAssetType.texture, "atlas_0.png");
        Game._LOADER.addAsset(eAtlas_0.NAME, pc.eAssetType.atlas, "atlas_0.json");

        Game._LOADER.addAsset(eAudioAsset.sfx, pc.eAssetType.audio, "audio/sfx.mp3");
        Game._LOADER.addAsset(eAudioAsset.music, pc.eAssetType.audio, "audio/music.mp3");

        Game._LOADER.load();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleLoaderComplete(): void {
        Game._APP.assets.filter((asset: pc.Asset): boolean => {
            if (asset.type == pc.eAssetType.texture) {
                if (asset.resource) {
                    asset.resource._minFilter = 0;
                    asset.resource._magFilter = 0;
                }
            }

            return false;
        });

        // Spustit gameplay
        this._gameplay = new Gameplay();
        Game._APP.on("update", this.handleAppUpdate, this);

        this.handleInitProgress(Game._FLAG_ASSETS_LOADED);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleInitProgress(progressFlag: number): void {
        this._flags |= progressFlag;

        if ((this._flags & (Game._FLAG_ASSETS_LOADED | Game._FLAG_GAMEE_INITIALIZED)) == (Game._FLAG_ASSETS_LOADED | Game._FLAG_GAMEE_INITIALIZED))
            Gamee.Wrapper.gameReady();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleAppUpdate(dt: number): void {
        //FPS_METER.tick();

        if (!Game._PAUSED)
            this._gameplay.update(dt);
    }
}



window.addEventListener("DOMContentLoaded", () => {
    new Game("renderCanvas");
});